var easings = {
    linear: function (t) { return t; },
    easeIn: function (t) { return t * t; },
    easeOut: function (t) { return t * (2 - t); },
    easeInOut: function (t) { return (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t); },
    easeInCubic: function (t) { return t * t * t; },
    easeOutCubic: function (t) { return --t * t * t + 1; },
    easeInOutCubic: function (t) { return (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1); },
    easeInQuart: function (t) { return t * t * t * t; },
    easeOutQuart: function (t) { return 1 - --t * t * t * t; },
    easeInOutQuart: function (t) { return (t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t); },
    easeInQuint: function (t) { return t * t * t * t * t; },
    easeOutQuint: function (t) { return 1 + --t * t * t * t * t; },
    easeInOutQuint: function (t) { return (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t); },
    easeInExpo: function (t) { return (t === 0 ? 0 : Math.pow(2, 10 * (t - 1))); },
    easeOutExpo: function (t) { return (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)); },
    easeInOutExpo: function (t) {
        if (t === 0)
            return 0;
        if (t === 1)
            return 1;
        if (t < 0.5)
            return Math.pow(2, 20 * t - 10) / 2;
        return (2 - Math.pow(2, -20 * t + 10)) / 2;
    },
    easeInCirc: function (t) { return 1 - Math.sqrt(1 - t * t); },
    easeOutCirc: function (t) { return Math.sqrt(1 - --t * t); },
    easeInOutCirc: function (t) {
        return t < 0.5 ? (1 - Math.sqrt(1 - 4 * t * t)) / 2 : (Math.sqrt(1 - (-2 * t + 2) * (-2 * t + 2)) + 1) / 2;
    },
    easeInBack: function (t) {
        var c = 1.70158;
        return t * t * ((c + 1) * t - c);
    },
    easeOutBack: function (t) {
        var c = 1.70158;
        return 1 + --t * t * ((c + 1) * t + c);
    },
    easeInOutBack: function (t) {
        var c = 1.70158 * 1.525;
        return t < 0.5
            ? (Math.pow(2 * t, 2) * ((c + 1) * 2 * t - c)) / 2
            : (Math.pow(2 * t - 2, 2) * ((c + 1) * (2 * t - 2) + c) + 2) / 2;
    },
    easeInElastic: function (t) {
        if (t === 0 || t === 1)
            return t;
        return -Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1.1) * 5 * Math.PI);
    },
    easeOutElastic: function (t) {
        if (t === 0 || t === 1)
            return t;
        return Math.pow(2, -10 * t) * Math.sin((t - 0.1) * 5 * Math.PI) + 1;
    },
    easeInOutElastic: function (t) {
        if (t === 0 || t === 1)
            return t;
        t *= 2;
        if (t < 1)
            return -0.5 * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1.1) * 5 * Math.PI);
        return 0.5 * Math.pow(2, -10 * (t - 1)) * Math.sin((t - 1.1) * 5 * Math.PI) + 1;
    },
    easeInBounce: function (t) { return 1 - easings.easeOutBounce(1 - t); },
    easeOutBounce: function (t) {
        var n1 = 7.5625;
        var d1 = 2.75;
        if (t < 1 / d1)
            return n1 * t * t;
        if (t < 2 / d1)
            return n1 * (t -= 1.5 / d1) * t + 0.75;
        if (t < 2.5 / d1)
            return n1 * (t -= 2.25 / d1) * t + 0.9375;
        return n1 * (t -= 2.625 / d1) * t + 0.984375;
    },
    easeInOutBounce: function (t) {
        return t < 0.5 ? (1 - easings.easeOutBounce(1 - 2 * t)) / 2 : (1 + easings.easeOutBounce(2 * t - 1)) / 2;
    },
};
export function getEasing(name) {
    var _a;
    if (typeof name === 'function')
        return name;
    return (_a = easings[name]) !== null && _a !== void 0 ? _a : easings.linear;
}
export function registerEasing(name, fn) {
    easings[name] = fn;
}
export { easings };
